import React from 'react';
import { Backdrop, CircularProgress, Box, Typography } from '@mui/material';
const Loader = ({ backdropopen, backdropmessage }) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 2 }}
      open={backdropopen}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="inherit" />
        <Typography
          variant="h5"
          sx={{
            mt: 2,
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.15)',
            color: '#FFFFFF'
          }}
        ></Typography>
      </Box>
    </Backdrop>
  );
};

export default Loader;
